import React from "react";
import { ITextBlock } from "@montana/models/generated/cms.interface";
import { RichText } from "@montana/shared/rich-text";

export const M00TextBlock: React.FC<ITextBlock> = React.memo((props: ITextBlock): JSX.Element | null => {
    const {
        content,
    } = props;

    if (!content) {
        return null;
    }

    return (
        <div className="text-block display-body">
            <RichText text={content} />
        </div>
    );
});